export default "__VITE_ASSET__CcuQwzkL__"